<template>
  <div>
    <cell title="审批意见"></cell>
    <van-form ref="approvalForm">
      <van-field
        class="msg-textarea"
        v-model="opinions"
        rows="3"
        type="textarea"
        placeholder="请输入审批意见"
        maxlength="300"
        show-word-limit
        :show-error="false"
        :show-error-message="'false'"
        :required="rules[0].required"
        :rules="rules"
        :disabled="active !== 'todo'"
      />
      <slot name="extraMiddle" />
      <div class="btns" v-if="active == 'todo'"><!-- approval(false) -->
        <van-button v-if="!btnGroup.other" :loading="btnLoading.ok" :loading-text="btnGroup.ok" size="small" @click="formValid(false)" type="info">{{ btnGroup.ok }}</van-button>
        <van-button v-if="!btnGroup.other" :loading="btnLoading.no" :loading-text="btnGroup.no" size="small" @click="formValid(true)" type="info">{{ btnGroup.no }}</van-button>
        <van-button v-if="btnGroup.other" :loading="btnLoading.other" :loading-text="btnGroup.other" size="small" @click="formValid()" type="info">{{ btnGroup.other }}</van-button>
        <van-button size="small" v-if="!!detailUrl" @click="handleDetail" plain hairline type="info">查看详情</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
    import {Button, Cell, Dialog, Form, Toast} from 'vant';
    import application from '@api/application';

    export default {
        name:'baseForm',
        components: { Dialog, Button, Toast, Form, Cell },
        props: {
          onValid: {
            type: [Function, Object],
            default: null
          },
          beforeSub: {
            type: [Function, Object],
            default: null
          },
          otherSub: {
            type: [Function, Object],
            default: null
          },
          submitData: {
            type: Object,
            default: {}
          },
          opinion: {
            type: String,
            default: ''
          },
          btnGroup: {
            type: Object,
            default() {
              return {
                no: '审批不通过',
                ok: '审批通过',
                other: ''
              }
            }
          }
        },
        data() {
            return {
              rules: [{ required: false }],
              btnLoading: {
                ok: false,
                no: false,
                other: false
              },
              opinions: '',
              businessId: '',
              procInstId: '', //当前流程实例ID
              taskId: '', //当前流程节点ID
              taskName: '', //当前流程节点名称
              detailUrl: null, //详情地址

              assignType: '', //节点类型   0 变量获取 1 处理人 2 候选人 3 候选组 4 会签
              assignCode: '', //候选组编码 岗位编码
              assignLevel: '', //层级 项目部 PD 分公司 BC 公司 CO
              businessType: '' //业务类型 0 项目
            }
        },
        created(){
          const { type, code, level, btype, businessId, procInstId, detailUrl, taskId, opinions } = this.$route.query
          if (type) {
              this.assignType = type
              this.assignCode = code
              this.assignLevel = level
              this.businessType = btype
          }
          if (opinions) {
            this.opinions = opinions
          }
          this.procInstId = procInstId
          this.businessId = businessId
          if (detailUrl) {
              this.detailUrl = decodeURIComponent(detailUrl)
          }
          this.taskId = taskId
        },
        watch: {
          opinion: {
            handler:function(val,oldval){
              this.opinions = val
            }
          }
        },
        computed: {
          active() {
            return this.$route.query.active
          },
          userInfo() {
            return localStorage.getItem("vuex") ? JSON.parse(localStorage.getItem("vuex")).user.userInfo : {}
          },
        },
        methods: {
            handleDetail(){
              let token = sessionStorage.getItem('token')
              this.$router.push({
                path:'/approve/matters/details',
                query:{
                  detailUrl:this.detailUrl,
                  token:token,
                  id:this.businessId,
                  businessType:this.$route.query.businessType
                }
              })
            },
            closeLoading() {
              if (this.btnLoading.ok) this.btnLoading.ok = false
              if (this.btnLoading.no) this.btnLoading.no = false
              if (this.btnLoading.other) this.btnLoading.other = false
            },
            otherSubm() {
              if (this.otherSub != null) {
                this.otherSub().then((res) => {
                  return this.submit(res)
                }).then(() => {
                  this.closeLoading()
                  done()
                }).catch(() => {
                  this.closeLoading()
                })
              }
            },
            otherSubmit(btn) {
            },
            formValid(reject) {
              if (this.onValid != null) {
                  this.onValid(reject).then((res) => {
                    let flag = (reject !== undefined) ? reject : res;
                    this.approval(flag)
                  }).catch(() => {
                    this.closeLoading()
                  })
              } else {
                this.approval(reject)
              }
            },
            approval(reject) {
              this.rules = [{ required: reject }]
              this.$refs.approvalForm.resetValidation()
              this.$nextTick(() => {
                this.$refs.approvalForm.validate().then((res) => {
                  if (!res) {
                    this.confirmSub(reject)
                  }
                }).catch(() => {
                  this.closeLoading()
                })
              })
            },
            confirmSub(reject) {
              Dialog.confirm({
                title: '提醒！',
                message: reject ? '确定审批不通过？' : '确定审批通过？',
                beforeClose: (action, done) => {
                  if (action === 'confirm') {
                    if (this.beforeSub != null) {
                        this.beforeSub({flag: reject, param: this.opinions}).then(() => {
                          return this.submit(reject)
                        }).then(() => {
                          this.closeLoading()
                          done()
                        }).catch(() => {
                          done()
                          this.closeLoading()
                        })
                    } else {
                      this.submit(reject).then(() => {
                        this.closeLoading()
                        done()
                      })
                    }
                  } else {
                    this.closeLoading()
                    done();
                  }
                }
              }).catch(() => {
                  this.closeLoading()
              })
            },
            submit(reject) {
              const data = {
                  formData: {
                      opinions: this.opinions,
                      reject,
                      projectId: ''
                  },
                  assignTypeEnum: this.assignType, //指派类型
                  // assgins: this.form.respEmployeeId, //人员
                  // groupEnum: this.form.jobsSelectedName, //岗位
                  procInstId: this.procInstId,
                  taskId: this.taskId,
                  userId: this.userInfo.userId
              }
              const variable = {}
              // return;
              if (reject) {
                  variable.reject = true
              }

              data.variables = {
                  ...variable,
                  ...this.submitData // 特殊流程的数据，转交给审批
              }

              return application.completeTask(data)
                  .then((res) => {
                      if (res.code === 200) {
                        Toast.success('审批成功');
                      }
                      this.toback()
                      return res
                  })
                  .catch((err) => {
                      return err
                  })
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .view {
        .content {
          .card-title {
            font-size: 1.6rem;
            font-weight: normal;
            padding: 1rem 1.6rem;
            color: #999;
            background: #f7f8fa;
          }
          .msg-textarea {
            ::v-deep .van-field__value {
                color: #969799;
              padding: 1rem;
              background: #f7f8fa;
            }
            background: none;
          }
          ::v-deep .cell-title {
            width: 8rem;
            flex: none;
          }
          .btns {
            overflow: hidden;
            padding: 1rem 1.6rem;
            ::v-deep .van-button {
              border-radius: 0.4rem;
              float: right;
              margin-left: 1rem;
            }
          }
          .item-box {
            display: flex;
            align-items: center;
            overflow: hidden;
            line-height: 2.4rem;
            font-size: 1.4rem;
            padding: 1rem 1.6rem;
            position: relative;
            &:active {
              background-color: #f2f3f5;
            }
            &::after {
              right: 0 !important;
              left: 0 !important;
              position: absolute;
              box-sizing: border-box;
              content: ' ';
              pointer-events: none;
              right: 1.6rem;
              bottom: 0;
              left: 1.6rem;
              border-bottom: 0.1rem solid #ebedf0;
              -webkit-transform: scaleY(.5);
              transform: scaleY(.5);
            }
            .item-left {
              width: 3rem;
              height: 3rem;
              line-height: 3rem;
              text-align: center;
              color: #fff;
              font-size: 1.6rem;
              border-radius: 100%;
              background: #169BD5;
              margin-right: 1rem;
            }
            .item-center {
              flex: 1;
              overflow: hidden;
              .item-title {
                display: flex;
                .title-name {
                  font-size: 1.6rem;
                  flex: 1;
                }
                .title-tag {
                  border-radius: 4px;
                  font-size: 1.2rem;
                  line-height: 2.4rem;
                  padding: 0 0.6rem;
                  margin-right: 1rem;
                  height: 2.4rem;
                }
                .title-tag-success {
                  color: #02A7F0;
                  border: 1px solid #02a7f0;
                  background: #02a7f019;
                }
                .title-tag-error {
                  color: #F5222D;
                  border: 1px solid #ffa39e;
                  background: #fef0ef;
                }
                .title-time {
                  max-width: 12rem;
                  text-align: right;
                  color: #999;
                }
              }
              .item-content {
                color: #999;
              }
              .item-subcontent {
                color: #999;
                font-size: 1.2rem;
              }
            }
            .item-right-icon {
              margin-left: 0.4rem;
              color: #969799;
            }
          }
            // padding-: 1rem;
        }
    }

</style>
